import { useState } from "react";
import { copyTextToClipboard } from "../../utils/helpers";
import { Icon } from "../icon/icon";

export const CopyButton = ({
  value,
  showIcon = true,
  text = "Copy",
  className = ''
}: {
  value: string;
  showIcon?: boolean;
  text?: string;
  className?: string;
}) => {
  const [buttonText, setButtonText] = useState(text);

  const handleClick = async () => {
    await copyTextToClipboard(value);
    setButtonText("Copied!");
    setTimeout(() => {
      setButtonText(text);
    }, 2000);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-fit items-center gap-[6px]"
    >
      {showIcon && <Icon svg="copy" width={16} height={16} />}
      <span className={className}>{buttonText}</span>
    </button>
  );
};
